import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getDescuentos,
  setDescuentoUsado,
  deleteDescuento,
  getDescuentoById,
  insertDescuento,
  updateDescuento,
  getDescuentosFiltered,
} from 'services/marketing'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'
import history from '../../history'

export function* GET_DESCUENTOS() {
  try {
    const descuentosData = yield call(getDescuentos)
    if (descuentosData.ok) {
      yield put({
        type: actions.DESCUENTOS_LOAD_SUCCEEDED,
        payload: descuentosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar descuentos')
      put({
        type: actions.DESCUENTOS_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar descuentos')
    yield all([
      put({
        type: actions.DESCUENTOS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}
export function* SET_DESCUENTO_USADO(action) {
  try {
    const descuentoData = yield call(setDescuentoUsado, action.payload)
    if (descuentoData.ok) {
      putMessage(messageType.SUCCESS, 'Cambios guardados correctamente')
      yield put({
        type: actions.SET_DESCUENTO_USADO_SUCCEEDED,
        payload: descuentoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al marcar/desmarcar el descuento')
      put({
        type: actions.SET_DESCUENTO_USADO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al marcar/desmarcar el descuento')
    yield all([
      put({
        type: actions.SET_DESCUENTO_USADO_FAILED,
        error: e.message,
      }),
    ])
  }
}
export function* DELETE_DESCUENTO(action) {
  try {
    const descuentoData = yield call(deleteDescuento, action.payload)
    if (descuentoData.ok) {
      putMessage(messageType.SUCCESS, 'Descuento eliminado correctamente')
      yield put({
        type: actions.DELETE_DESCUENTO_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar el descuento')
      put({
        type: actions.DELETE_DESCUENTO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar el descuento')
    yield all([
      put({
        type: actions.DELETE_DESCUENTO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_DESCUENTO_BY_ID(action) {
  try {
    const descuentoData = yield call(getDescuentoById, action.payload)
    if (descuentoData.ok) {
      yield put({
        type: actions.DESCUENTO_BYID_LOAD_SUCCEEDED,
        payload: descuentoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Descuento')
      put({
        type: actions.DESCUENTO_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Descuento')
    yield all([
      put({
        type: actions.DESCUENTO_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_DESCUENTO(action) {
  try {
    const descuentoObj = yield call(insertDescuento, action.payload)
    if (descuentoObj.ok) {
      putMessage(messageType.SUCCESS, 'Descuento creado correctamente')
      if (descuentoObj.data.length > 1) history.push('/descuentos/list')
      else if (descuentoObj.data.length === 1)
        history.push(`/descuentos/edit/${descuentoObj.data[0].id}`)
      yield put({
        type: actions.DESCUENTO_INSERT_SUCCEEDED,
        payload: descuentoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Descuento')
      yield put({
        type: actions.DESCUENTO_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Descuento')
    yield all([
      put({
        type: actions.DESCUENTO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_DESCUENTO(action) {
  try {
    const descuentoObj = yield call(updateDescuento, action.payload)
    if (descuentoObj.ok) {
      putMessage(messageType.SUCCESS, 'Descuento modificado correctamente')
      yield put({
        type: actions.DESCUENTO_UPDATE_SUCCEEDED,
        payload: descuentoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Descuento')
      yield put({
        type: actions.DESCUENTO_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Descuento')
    yield all([
      put({
        type: actions.DESCUENTO_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_DESCUENTOS_FILTERED(action) {
  try {
    const descuentosData = yield call(getDescuentosFiltered, action.payload)
    if (descuentosData.ok) {
      yield put({
        type: actions.DESCUENTOS_FILTERED_LOAD_SUCCEEDED,
        payload: descuentosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar artículos')
      put({
        type: actions.DESCUENTOS_FILTERED_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.DESCUENTOS_FILTERED_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DESCUENTOS_LOAD_REQUESTED, GET_DESCUENTOS),
    takeEvery(actions.SET_DESCUENTO_USADO_REQUESTED, SET_DESCUENTO_USADO),
    takeEvery(actions.DELETE_DESCUENTO_REQUESTED, DELETE_DESCUENTO),
    takeEvery(actions.DESCUENTO_BYID_LOAD_REQUESTED, GET_DESCUENTO_BY_ID),
    takeEvery(actions.DESCUENTO_UPDATE_REQUESTED, UPDATE_DESCUENTO),
    takeEvery(actions.DESCUENTO_INSERT_REQUESTED, INSERT_DESCUENTO),
    takeEvery(actions.DESCUENTOS_FILTERED_LOAD_REQUESTED, GET_DESCUENTOS_FILTERED),
  ])
}
